var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c("vue-snotify"),
      _c(
        "v-toolbar",
        { staticClass: "color-header-bar" },
        [
          _c("v-toolbar-title", [
            _c("div", {
              staticClass: "logo-sidebar",
              attrs: { title: "Ir al Inicio" }
            })
          ])
        ],
        1
      ),
      _c(
        "v-content",
        { staticClass: "bimg" },
        [
          !_vm.paso1_ok &&
          !_vm.recuperarPass &&
          !_vm.correoEnviado &&
          !_vm.contactarEjecutivo &&
          !_vm.usuarioBloqueado
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "25px" }
                                          },
                                          [_vm._v("Ingresa con tu correo")]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "13px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Ingresa el correo con el cual estás registrado en la\n                    plataforma\n                  "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-form",
                                    {
                                      attrs: {
                                        "lazy-validation": "",
                                        onkeypress:
                                          "return event.keyCode != 13;"
                                      },
                                      model: {
                                        value: _vm.validForm,
                                        callback: function($$v) {
                                          _vm.validForm = $$v
                                        },
                                        expression: "validForm"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|emailValido",
                                            expression: "'required|emailValido'"
                                          }
                                        ],
                                        attrs: {
                                          id: "txtEmail",
                                          "data-testid":
                                            "Login__v-text-field--email",
                                          autofocus: "",
                                          "prepend-icon": "person_outline",
                                          "error-messages": _vm.errors.collect(
                                            "email"
                                          ),
                                          "data-vv-name": "email",
                                          label: "Correo Electrónico",
                                          type: "email",
                                          placeholder: " ",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.userData.email,
                                          callback: function($$v) {
                                            _vm.$set(_vm.userData, "email", $$v)
                                          },
                                          expression: "userData.email"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          id: "txtPass",
                                          "data-testid":
                                            "Login__v-text-field--password",
                                          "prepend-icon": "lock",
                                          "append-icon": _vm.show1
                                            ? "visibility_off"
                                            : "visibility",
                                          "error-messages": _vm.errors.collect(
                                            "contraseña"
                                          ),
                                          "data-vv-name": "contraseña",
                                          type: _vm.show1 ? "text" : "password",
                                          name: "input-10-1",
                                          label: "Contraseña",
                                          placeholder: " ",
                                          required: ""
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.show1 = !_vm.show1
                                          }
                                        },
                                        model: {
                                          value: _vm.userData.password,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.userData,
                                              "password",
                                              $$v
                                            )
                                          },
                                          expression: "userData.password"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "justify-content": "center",
                                    "align-items": "center"
                                  }
                                },
                                [
                                  _c("div", {
                                    ref: "recaptcha",
                                    staticClass: "g-recaptcha"
                                  })
                                ]
                              ),
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    "align-center": "",
                                    "justify-start": "",
                                    row: "",
                                    "fill-height": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "padding-left": "10px" },
                                      attrs: { xs6: "" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { cursor: "pointer" } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.contactarEjecutivo = true
                                                }
                                              }
                                            },
                                            [_vm._v("¿Necesitas contactarnos?")]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        "text-align": "end",
                                        "padding-right": "10px"
                                      },
                                      attrs: { xs6: "" }
                                    },
                                    [
                                      _c("span", {
                                        staticStyle: { cursor: "pointer" }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        "align-center": "",
                                        "justify-start": "",
                                        row: "",
                                        "fill-height": ""
                                      }
                                    },
                                    [_c("SolicitarClave")],
                                    1
                                  ),
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-flex", [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "padding-right": "10px"
                                            },
                                            attrs: { align: "right" }
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  id: "btnContinuar",
                                                  "data-testid":
                                                    "Login__continuar",
                                                  color: "#526da5",
                                                  depressed: true,
                                                  disabled:
                                                    _vm.showRecaptcha_v2 ||
                                                    !_vm.validForm
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.login()
                                                  },
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    return _vm.login()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Continuar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.paso1_ok &&
          !_vm.recuperarPass &&
          !_vm.debeCambiarPass &&
          !_vm.correoEnviado &&
          !_vm.usuarioBloqueado
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { "padding-right": "70px" },
                                  attrs: { align: "center" }
                                },
                                [_c("br")]
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "25px" }
                                          },
                                          [_vm._v(_vm._s(_vm.username))]
                                        )
                                      ]),
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "25px" }
                                          },
                                          [_vm._v("Validando...")]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "14px" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.userData.email) +
                                                "  \n                    "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  sytle: "color:#808080"
                                                }
                                              },
                                              [_vm._v("|")]
                                            ),
                                            _vm._v("  \n                  ")
                                          ]
                                        ),
                                        _c(
                                          "a",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.back()
                                              }
                                            }
                                          },
                                          [_vm._v("¿No es tu cuenta?")]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-form",
                                    {
                                      attrs: {
                                        "lazy-validation": "",
                                        onkeypress:
                                          "return event.keyCode != 13;"
                                      },
                                      model: {
                                        value: _vm.validForm2,
                                        callback: function($$v) {
                                          _vm.validForm2 = $$v
                                        },
                                        expression: "validForm2"
                                      }
                                    },
                                    [_c("br")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", [
                                        _c(
                                          "div",
                                          { attrs: { align: "right" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  id: "btnLogin",
                                                  "data-testid": "Login__login",
                                                  color: "#526da5",
                                                  depressed: true,
                                                  disabled:
                                                    _vm.showRecaptcha_v2 ||
                                                    !_vm.validForm2
                                                },
                                                on: {
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    return _vm.login()
                                                  },
                                                  click: function($event) {
                                                    return _vm.login()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Continuar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.recuperarPass && !_vm.correoEnviado
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { "padding-right": "70px" },
                                  attrs: { align: "center" }
                                },
                                [_c("br")]
                              ),
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "25px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.limitString(_vm.username, 35)
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.userData.email) + "  |  "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.back()
                                            }
                                          }
                                        },
                                        [_vm._v("¿No es tu cuenta?")]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    ¿Desea crear una nueva contraseña para la cuenta asociada\n                    a su correo " +
                                              _vm._s(_vm.userData.email) +
                                              "?\n                  "
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c(
                                          "div",
                                          { attrs: { align: "left" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  depressed: true,
                                                  color: "#526da5"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.back()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Volver")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _c("v-flex", [
                                        _c(
                                          "div",
                                          { attrs: { align: "right" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  depressed: true,
                                                  color: "#526da5"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.crearContraseña()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Crear Contraseña")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.paso1_ok && _vm.debeCambiarPass && !_vm.correoEnviado
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "25px" }
                                          },
                                          [_vm._v("Actualizar Contraseña")]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "13px" }
                                          },
                                          [
                                            _vm._v(
                                              "Debe actualizar su contraseña antes de ingresar al\n                    sistema"
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-form",
                                    {
                                      ref: "form",
                                      attrs: { "lazy-validation": "" },
                                      model: {
                                        value: _vm.validFormActualizaPass,
                                        callback: function($$v) {
                                          _vm.validFormActualizaPass = $$v
                                        },
                                        expression: "validFormActualizaPass"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.paso1_ok &&
                                              !_vm.debeCambiarPass &&
                                              _vm.correoEnviado,
                                            expression:
                                              "!paso1_ok && !debeCambiarPass && correoEnviado"
                                          }
                                        ]
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          autocomplete: "false",
                                          readonly: "",
                                          onfocus:
                                            "this.removeAttribute('readonly');",
                                          "prepend-icon": "lock_open",
                                          "append-icon": _vm.show2
                                            ? "visibility_off"
                                            : "visibility",
                                          label: "Contraseña Actual",
                                          type: _vm.show2 ? "text" : "password",
                                          rules: _vm.passRules1,
                                          counter: 20,
                                          required: ""
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.show2 = !_vm.show2
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.userDataChangePass.contrasena1,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.userDataChangePass,
                                              "contrasena1",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "userDataChangePass.contrasena1"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|max:20|min:8",
                                            expression:
                                              "'required|max:20|min:8'"
                                          }
                                        ],
                                        attrs: {
                                          "prepend-icon": "lock_open",
                                          autocomplete: "new-password",
                                          readonly: "",
                                          onfocus:
                                            "this.removeAttribute('readonly');",
                                          "append-icon": _vm.show3
                                            ? "visibility_off"
                                            : "visibility",
                                          label: "Nueva Contraseña",
                                          type: _vm.show3 ? "text" : "password",
                                          rules: _vm.passRules2,
                                          counter: 20,
                                          required: ""
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.show3 = !_vm.show3
                                          },
                                          keyup: function($event) {
                                            return _vm.changeInput()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.userDataChangePass.contrasena2,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.userDataChangePass,
                                              "contrasena2",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "userDataChangePass.contrasena2"
                                        }
                                      }),
                                      _c("v-text-field", {
                                        attrs: {
                                          "prepend-icon": "lock_open",
                                          autocomplete: "new-password",
                                          readonly: "",
                                          onfocus:
                                            "this.removeAttribute('readonly');",
                                          "append-icon": _vm.show4
                                            ? "visibility_off"
                                            : "visibility",
                                          "data-vv-name": "contrasena3",
                                          label: "Repita Contraseña",
                                          type: _vm.show4 ? "text" : "password",
                                          rules: _vm.passRules3,
                                          counter: 20,
                                          required: ""
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.show4 = !_vm.show4
                                          },
                                          keyup: function($event) {
                                            return _vm.changeInput()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.userDataChangePass.contrasena3,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.userDataChangePass,
                                              "contrasena3",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "userDataChangePass.contrasena3"
                                        }
                                      }),
                                      _c("br")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c(
                                          "div",
                                          { attrs: { align: "left" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  id: "btnVolver",
                                                  color: "#526da5",
                                                  depressed: true
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.paso1_ok = false
                                                    _vm.debeCambiarPass = false
                                                    _vm.correoEnviado = false
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Volver")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _c("v-flex", [
                                        _c(
                                          "div",
                                          { attrs: { align: "right" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  id: "btnAceptar",
                                                  color: "#526da5",
                                                  disabled: !_vm.validFormActualizaPass
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.actualizarPassLogin()
                                                  },
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    return _vm.actualizarPassLogin()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Aceptar")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _c("br"),
                                      _c("br"),
                                      _c("br"),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("v-divider"),
                                          _c(
                                            "v-expansion-panel",
                                            [
                                              _c(
                                                "v-expansion-panel-content",
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px"
                                                      },
                                                      attrs: { slot: "header" },
                                                      slot: "header"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Reglas de contraseña\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c("v-card-text", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "* Debe tener un largo mínimo de 8\n                            caracteres."
                                                            )
                                                          ]
                                                        ),
                                                        _c("br"),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "* Debe tener un largo máximo de 20\n                            caracteres."
                                                            )
                                                          ]
                                                        ),
                                                        _c("br"),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            * Debe contener al menos una mayúscula ('A'-'Z').\n                          "
                                                            )
                                                          ]
                                                        ),
                                                        _c("br"),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            * Debe contener al menos una minúscula ('a'-'z').\n                          "
                                                            )
                                                          ]
                                                        ),
                                                        _c("br"),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "* Debe contener al menos un número\n                            ('0'-'9')."
                                                            )
                                                          ]
                                                        ),
                                                        _c("br"),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "* Debe contener al menos un símbolo [. , # @ -\n                            _]."
                                                            )
                                                          ]
                                                        ),
                                                        _c("br"),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px"
                                                            },
                                                            attrs: {
                                                              align: "left"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            * Debe ser una contraseña no utilizada con\n                            anterioridad.\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.correoEnviado
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "25px" }
                                        },
                                        [_vm._v(_vm._s(_vm.username))]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "13px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Hemos enviado las instrucciones para cambiar su contraseña\n                    al correo\n                  "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "13px" }
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.email))
                                          ])
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br")
                              ]),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "div",
                                          { attrs: { align: "center" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  id: "btnCorreo",
                                                  color: "#526da5",
                                                  depressed: true
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.correoEnviado = false
                                                    _vm.paso1_ok = false
                                                    _vm.recuperarPass = false
                                                    _vm.limpiarForm()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Volver")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.contactarEjecutivo && !_vm.paso1_ok
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "25px" }
                                        },
                                        [_vm._v("Contacto")]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "13px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Estimado usuario, por favor contacte a su ejecutivo de\n                    cuenta o a nuestra mesa central.\n                  "
                                          )
                                        ]
                                      ),
                                      _c("br"),
                                      _c("br")
                                    ]),
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "13px" }
                                        },
                                        [_c("strong", [_vm._v("Mesa Central")])]
                                      ),
                                      _c("br"),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "13px" }
                                        },
                                        [_vm._v("(+56) 2 2940 4911")]
                                      ),
                                      _c("br"),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "13px" }
                                        },
                                        [_vm._v("clientes@gpschile.com")]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br")
                              ]),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { md12: "" } }, [
                                        _c(
                                          "div",
                                          { attrs: { align: "center" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  type: "button",
                                                  id: "btnCorreo",
                                                  color: "#526da5",
                                                  depressed: true
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.correoEnviado = false
                                                    _vm.paso1_ok = false
                                                    _vm.recuperarPass = false
                                                    _vm.contactarEjecutivo = false
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Volver")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.usuarioBloqueado && !_vm.correoEnviado
            ? _c(
                "v-container",
                {
                  staticClass: "animated fadeIn fast",
                  attrs: { fluid: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "", md5: "" } },
                        [
                          _c("div", {
                            staticClass: "logo-login",
                            attrs: { title: "Ir al Inicio" }
                          }),
                          _c(
                            "v-card",
                            { staticClass: "elevation-12" },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { "padding-right": "70px" },
                                  attrs: { align: "center" }
                                },
                                [_c("br")]
                              ),
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "25px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.limitString(_vm.username, 35)
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.userData.email) + "  |  "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.back()
                                            }
                                          }
                                        },
                                        [_vm._v("¿No es tu cuenta?")]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("br"),
                                _c(
                                  "div",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "14px" }
                                        },
                                        [_vm._v(_vm._s(_vm.mensajeBloqueado))]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "v-card-actions",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("v-flex", { attrs: { xs6: "" } }, [
                                        _c(
                                          "div",
                                          { attrs: { align: "left" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  depressed: true,
                                                  color: "#526da5"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.back()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Volver")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _c("v-flex", [
                                        _c(
                                          "div",
                                          { attrs: { align: "right" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.usuarioBloqueadoBtn,
                                                    expression:
                                                      "usuarioBloqueadoBtn"
                                                  }
                                                ],
                                                attrs: {
                                                  depressed: true,
                                                  color: "#526da5"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.crearContraseña()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v("Crear Contraseña")]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c("br")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-layout",
            { attrs: { row: "", "justify-center": "" } },
            [
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", width: "390", "max-width": "390" },
                  model: {
                    value: _vm.dialogSesionExpirada,
                    callback: function($$v) {
                      _vm.dialogSesionExpirada = $$v
                    },
                    expression: "dialogSesionExpirada"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dark: "", color: "primary" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialogSesionExpirada = false
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                          _c(
                            "v-toolbar-title",
                            {
                              staticStyle: {
                                "font-size": "17px",
                                "margin-left": "10px !important"
                              }
                            },
                            [_vm._v("Sesión Expirada")]
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            Su sesión de trabajo ha expirado, por lo que usted fue\n            redireccionado(a) al inicio de sesión.\n          "
                        )
                      ]),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", depressed: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialogSesionExpirada = false
                                }
                              }
                            },
                            [_vm._v("Aceptar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { row: "", "justify-center": "" } },
            [
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", width: "390", "max-width": "390" },
                  model: {
                    value: _vm.dialogpermisosModificados,
                    callback: function($$v) {
                      _vm.dialogpermisosModificados = $$v
                    },
                    expression: "dialogpermisosModificados"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dark: "", color: "primary" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialogpermisosModificados = false
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                          _c(
                            "v-toolbar-title",
                            {
                              staticStyle: {
                                "font-size": "17px",
                                "margin-left": "10px !important"
                              }
                            },
                            [_vm._v("Cierre de sesión")]
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("v-card-text", [
                        _vm._v(
                          "Su usuario ha sido modificado. Favor ingrese\n            nuevamente."
                        )
                      ]),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", depressed: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialogpermisosModificados = false
                                }
                              }
                            },
                            [_vm._v("Aceptar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }